import Config from 'services/config/config';
import callWebService, { callTypes } from 'services/utils/networks/network';
import {
  RM_SOFTWARE_TICKET,
  RM_SOFTWARE_TICKET_FILTER
} from './type';

export const fetchRmSoftwareTicket = (filterData = null, page = 1, filterFlag = false) => async (
    dispatch
  ) => {
    dispatch({
      type: RM_SOFTWARE_TICKET,
      payload: null,
    });
    console.log(filterData)
    const res = await callWebService(
      callTypes.get,
      '',
      filterData === null
        ? `${Config.maintenance.rmSoftwareList}?page=${page}`
        : `${Config.maintenance.rmSoftwareList}?status=${filterData.status}&site_no=${filterData.site_no}&client_name=${filterData.client_name}&assignee_id=${filterData.assignee_ids}&fromDate=${filterData.fromDate}&toDate=${filterData.toDate}&fd_ticket_id=${filterData.fd_ticket_id}&fusion_ticket_id=${filterData.fusion_ticket_id}&city_id=${filterData.city_id}&page=${page}&flag=${filterFlag}`
    );
    if (res) {
      const { data } = res;
      dispatch({
        type: RM_SOFTWARE_TICKET,
        payload: data.response.data,
      });
      return true;
    }
  };

  export const getRmSoftwareTicketsFilterDropDown = (filterStatusCheck = 1) => async (dispatch) => {
    const res = await callWebService(
      callTypes.get,
      '',
      `${Config.maintenance.rmSoftwareTicketsFilters}?filterStatusCheck=${filterStatusCheck}`
    );
    if (res) {
      const { data } = res;
      dispatch({
        type: RM_SOFTWARE_TICKET_FILTER,
        payload: data.response.data,
      });
      return true;
    }
  };